// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/sdpMessage';

/** 标记消息已读(符合条件的全部) POST /api/v2/message/record/all/mark-read */
export async function recordAllMarkRead(
  body: APISdpMessage.MarkAllMessageReadRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.BaseResponse>('/api/v2/message/record/all/mark-read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 标记消息删除(批量) POST /api/v2/message/record/batch/mark-delete */
export async function recordBatchMarkDelete(
  body: APISdpMessage.MarkBatchMessageDeleteRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.BaseResponse>('/api/v2/message/record/batch/mark-delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 标记消息已读(批量) POST /api/v2/message/record/batch/mark-read */
export async function recordBatchMarkRead(
  body: APISdpMessage.MarkBatchMessageReadRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.BaseResponse>('/api/v2/message/record/batch/mark-read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 游标分页查询消息记录 POST /api/v2/message/record/cursor/list */
export async function recordCursorList(
  body: APISdpMessage.QueryCursorMessageRecordRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.CursorPaginationResponseMessageRecordDto_>(
    '/api/v2/message/record/cursor/list',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询消息记录详情 POST /api/v2/message/record/detail */
export async function messageRecordDetail(
  body: APISdpMessage.QueryMessageDetailRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.CommonResponseMessageRecordDetailDto_>(
    '/api/v2/message/record/detail',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询最近一条未读消息记录 POST /api/v2/message/record/latest-unread */
export async function messageRecordLatestUnread(
  body: APISdpMessage.QueryLatestUnreadMessageRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.CommonResponseMessageRecordDetailDto_>(
    '/api/v2/message/record/latest-unread',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 传统分页查询消息记录 POST /api/v2/message/record/page/list */
export async function recordPageList(
  body: APISdpMessage.QueryMessageRecordRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.PageResponseMessageRecordDto_>('/api/v2/message/record/page/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 统计消息已读/未读数量(根据messageType分组) POST /api/v2/message/record/read-status-stats */
export async function messageRecordReadStatusStats(
  body: APISdpMessage.CountUserMessageStatusStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.ListResponseMessageReadStatusStatsDto_>(
    '/api/v2/message/record/read-status-stats',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 标记消息删除(单条) POST /api/v2/message/record/single/mark-delete */
export async function recordSingleMarkDelete(
  body: APISdpMessage.MarkSingleMessageDeleteRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.BaseResponse>('/api/v2/message/record/single/mark-delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 标记消息已读(单条) POST /api/v2/message/record/single/mark-read */
export async function recordSingleMarkRead(
  body: APISdpMessage.MarkSingleMessageReadRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.BaseResponse>('/api/v2/message/record/single/mark-read', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 统计未读消息数量 POST /api/v2/message/record/unread-count */
export async function messageRecordUnreadCount(
  body: APISdpMessage.CountUserMessageStatusStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APISdpMessage.CommonResponseCountUnreadDto_>(
    '/api/v2/message/record/unread-count',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
